var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatConversationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6763 31.9809C24.9891 31.6303 30 26.4005 30 20C30 13.3726 24.6274 8 18 8C11.3726 8 6 13.3726 6 20C6 22.3614 6.68188 24.5634 7.85978 26.4199L7.01172 28.9641L7.01037 28.9678C6.68555 29.9423 6.52307 30.4297 6.63877 30.7542C6.73959 31.0369 6.96337 31.2598 7.24609 31.3606C7.56945 31.4759 8.05349 31.3145 9.02138 30.9919L9.03516 30.9877L11.5801 30.1396C13.4366 31.3175 15.6387 31.9996 18.0001 31.9996C18.227 31.9996 18.4525 31.9933 18.6763 31.9809ZM18.6763 31.9809C18.6764 31.9814 18.6761 31.9804 18.6763 31.9809ZM18.6763 31.9809C20.3181 36.6518 24.7682 40.0003 30.0003 40.0003C32.3617 40.0003 34.5633 39.3176 36.4197 38.1396L38.9641 38.9877L38.969 38.9887C39.9433 39.3135 40.4317 39.4762 40.7561 39.3606C41.0388 39.2597 41.2597 39.0369 41.3606 38.7541C41.4764 38.4292 41.3144 37.9412 40.9887 36.9641L40.1406 34.4199L40.4247 33.9492C41.4276 32.1959 41.9989 30.1646 41.9989 28C41.9989 21.3726 36.6274 16 30 16L29.5508 16.0083L29.3242 16.0193",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatConversationCircle);
export default __webpack_public_path__ + "static/media/Chat_Conversation_Circle.dfa3bd43139e230092ae6d55637bc5c0.svg";
export { ForwardRef as ReactComponent };